export default (centAmount: number) => {
  const minimumFractionDigits = centAmount % 100 ? 2 : 0;

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
  }).format(centAmount / 100);
};
